export const contactsModel = data => {
  const { phones: contactsPhones = [], emails: contactsEmails = [] } = data

  const phones = contactsPhones.map(({ title, number }) => ({ title, number }))
  const emails = contactsEmails.map(({ title, address }) => ({ title, address }))

  return { phones, emails }
}
